




import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconDot extends Vue {
    @Prop({ type: Number, default: 48 }) readonly size!: number

}
